import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-arcs-3', 'IconChartArcs3', [
  ['path', { d: 'M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-0' }],
  ['path', { d: 'M7 12a5 5 0 1 0 5 -5', key: 'svg-1' }],
  ['path', { d: 'M6.29 18.957a9 9 0 1 0 5.71 -15.957', key: 'svg-2' }],
]);
